export const getMode = state => state.theme.theme;
